import { render, staticRenderFns } from "@/components/Layout/Menu/Gestores/Siniestros/Files_siniestros/Files_siniestros.html?vue&type=template&id=6008bfd5&scoped=true&"
import script from "@/components/Layout/Menu/Gestores/Siniestros/Files_siniestros/Files_siniestros.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Gestores/Siniestros/Files_siniestros/Files_siniestros.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Gestores/Siniestros/Files_siniestros/Files_siniestros.css?vue&type=style&index=0&id=6008bfd5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6008bfd5",
  null
  
)

export default component.exports